<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('pick_up_hours') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="px-2">
          <v-radio-group v-model="time" :mandatory="false" hide-details>
            <v-radio :label="$t('pick_up_now')" value="now" color="primary" />
            <v-radio :label="$t('half_hour_come')" value="half_hour" color="primary" />
            <v-radio :label="$t('one_hour_come')" value="one_hour" color="primary" />
            <v-radio :label="$t('two_hour_come')" value="two_hour" color="primary" />
            <v-radio label="Custom" value="custom" color="primary" />
            <vue-timepicker
              v-if="time === 'custom'"
              v-model="take_time"
              :format="format_take_time"
              :minute-interval="15"
              :hour-range="default_hour_range"
              :minute-range="default_minute_range"
              close-on-complete
              advanced-keyboard
              hide-clear-button
              hide-disabled-hours
              hide-disabled-minutes
              :placeholder="$t('time')"
              class="__time time-to-take"
            />
          </v-radio-group>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <div class="__menu-bottom menu-full">
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <v-btn type="submit" color="primary" :disabled="nextDisable" block x-large class="text-none" @click="selectMenu">
            {{ $t('select_menu') }}
          </v-btn>
        </v-col>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      time: '',
      nextDisable: true,
      take_time: {},
      format_take_time: 'HH:mm',
      default_hour_range: [],
      default_minute_range: [],
      sendToForm: {
        take_time: '',
        item: []
      },
      working_time: {}
    }
  },
  watch: {
    time: function(newItem, oldItem) {
      if (newItem && newItem !== 'custom') {
        this.nextDisable = false
      } else {
        this.nextDisable = true
      }
    },
    take_time: function(newItem, oldItem) {
      if (newItem.HH !== '' && newItem.mm !== '') {
        this.nextDisable = false
      }
      const today = new Date()
      const curHr = today.getHours()
      const curMt = today.getMinutes()
      const thh = parseFloat(newItem.HH)
      var startTimeM = []
      var startTimeH = []
      var endTimeH = []
      var endTimeM = []
      this.working_time.times.map(item => {
        const arrStartTime = item.fstart_time.split(':')
        startTimeH.push(Number(arrStartTime[0]))
        startTimeM.push(Number(arrStartTime[1]))
        const arrEndTime = item.fend_time.split(':')
        endTimeH.push(Number(arrEndTime[0]))
        endTimeM.push(Number(arrEndTime[1]))
      })
      const x = startTimeH.indexOf(thh)
      const i = endTimeH.indexOf(thh)
      if (i !== -1) {
        if (endTimeM[i] >= 45) {
          this.default_minute_range = [0, 15, 30, 45]
        } else if (endTimeM[i] >= 30) {
          this.default_minute_range = [0, 15, 30]
        } else if (endTimeM[i] >= 15) {
          this.default_minute_range = [0, 15]
        } else if (endTimeM[i] >= 0) {
          this.default_minute_range = [0]
        }
      } else if (x !== -1) {
        if (startTimeM[x] >= 30) {
          this.default_minute_range = [45]
        } else if (startTimeM[x] >= 15) {
          this.default_minute_range = [30, 45]
        } else if (startTimeM[x] >= 0) {
          this.default_minute_range = [15, 30, 45]
        }
      } else if (thh === curHr) {
        if (curMt >= 45) {
          this.default_hour_range.shift()
          this.default_minute_range = [0, 15, 30, 45]
        } else if (curMt >= 30) {
          this.default_minute_range = [45]
        } else if (curMt >= 15) {
          this.default_minute_range = [30, 45]
        } else if (curMt >= 0) {
          this.default_minute_range = [15, 30, 45]
        }
      } else {
        this.default_minute_range = [0, 15, 30, 45]
      }
    }
  },
  mounted() {
    this.defaultTimeRange()
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'listoutlets' }).catch(() => {})
    },
    async defaultTimeRange() {
      const selected_store = this.$store.state.selected_outlet
      const today = new Date()
      const curTd = today.getDay()
      const curHr = today.getHours()
      const curMt = today.getMinutes()
      if (curTd === 0) {
        this.working_time = selected_store.working_hours[6]
      } else {
        this.working_time = selected_store.working_hours[curTd - 1]
      }
      var startTimeH = []
      var startTimeM = []
      var endTimeH = []
      var endTimeM = []
      this.working_time.times.map(item => {
        const arrStartTime = item.fstart_time.split(':')
        startTimeH.push(Number(arrStartTime[0]))
        startTimeM.push(Number(arrStartTime[1]))
        const arrEndTime = item.fend_time.split(':')
        endTimeH.push(Number(arrEndTime[0]))
        endTimeM.push(Number(arrEndTime[1]))
        const defaultStartH = Number(arrStartTime[0])
        const defaultEndH = Number(arrEndTime[0])
        for (var i = defaultStartH; i < (defaultEndH + 1); i++) {
          if (i >= curHr) {
            this.default_hour_range.push(i)
          }
        }
      })

      const x = startTimeH.indexOf(curHr)
      if (x !== -1) {
        if (curMt > startTimeM[0]) {
          // setelah toko buka
          if (curMt >= 45) {
            this.default_hour_range.shift()
            this.default_minute_range = [0, 15, 30, 45]
          } else if (curMt >= 30) {
            this.default_minute_range = [45]
          } else if (curMt >= 15) {
            this.default_minute_range = [30, 45]
          } else if (curMt >= 0) {
            this.default_minute_range = [15, 30, 45]
          }
        } else {
          // sebelum toko buka
          if (startTimeM[0] >= 45) {
            this.default_hour_range.shift()
            this.default_minute_range = [0, 15, 30, 45]
          } else if (startTimeM[0] >= 30) {
            this.default_minute_range = [45]
          } else if (startTimeM[0] >= 15) {
            this.default_minute_range = [30, 45]
          } else if (startTimeM[0] >= 0) {
            this.default_minute_range = [15, 30, 45]
          }
        }
      } else {
        startTimeH.map(data => {
          if (curHr <= data) {
            const z = startTimeH.indexOf(data)
            if (startTimeM[z] >= 45) {
              if (this.default_hour_range.length > 1) {
                this.default_hour_range.shift()
                this.default_minute_range = [0, 15, 30, 45]
              }
            } else if (startTimeM[z] >= 30) {
              this.default_minute_range = [45]
            } else if (startTimeM[z] >= 15) {
              this.default_minute_range = [30, 45]
            } else if (startTimeM[z] >= 0) {
              this.default_minute_range = [15, 30, 45]
            }
          }
        })

        const x = endTimeM.indexOf(0)
        if (x !== -1) {
          const y = this.default_hour_range.indexOf(endTimeH[x])
          if (y !== -1) {
            this.default_hour_range.splice(y, 1)
          }
        }
      }

      // hapus jam yg buka dengan dengan menit 45, karena saat toko pesan hanya bisa di ambil minimal 15 menit setelah toko buka
      const i = startTimeM.indexOf(45)
      const index = this.default_hour_range.indexOf(startTimeH[i])
      if (index !== -1) {
        this.default_hour_range.splice(index, 1)
      }
    },
    selectMenu() {
      const today = new Date()
      var curHr = today.getHours()
      var curMt = today.getMinutes()
      if (this.time === 'custom') {
        const hour = this.take_time.HH
        const minute = this.take_time.mm
        this.sendToForm.take_time = hour + ':' + minute
      } else {
        if (this.time === 'half_hour') {
          curMt = curMt + 30
          if (curMt >= 60) {
            curMt = curMt - 60
            curHr = curHr + 1
          }
        } else if (this.time === 'one_hour') {
          curHr = curHr + 1
        } else if (this.time === 'one_hour') {
          curHr = curHr + 1
        } else if (this.time === 'two_hour') {
          curHr = curHr + 2
        }
        if (curHr < 10) {
          curHr = '0' + curHr
        }
        if (curMt < 10) {
          curMt = '0' + curMt
        }
        this.sendToForm.take_time = curHr + ':' + curMt
      }
      this.$store.dispatch('saveDataCartTakeAway', this.sendToForm)
      this.$router.push({ name: 'take_away_menu' }).catch(() => {})
    }
  }
}
</script>
